import SiteShell from "@/components/feature/SiteShell";
import RevealOnScroll from "@/components/base/RevealOnScroll";
import HeroCarousel from "./components/HeroCarousel";
import CategoryEntries from "./components/CategoryEntries";
import NewsStrip from "./components/NewsStrip";
import TrendingSection from "./components/TrendingSection";
import AboutTeaser from "./components/AboutTeaser";

export default function Home() {
  return (
    <SiteShell
      breadcrumb="/"
      pageTitle="长日光阴 - 综合影视娱乐门户"
      pageDescription="长日光阴网站致力于提供最新电影、电视剧资讯和影视资源，覆盖各类热门影视作品，满足用户多样化的观影需求。"
      pageKeywords="长日光阴,影视资讯,电影推荐,电视剧更新,影视资源,影视娱乐,影视作品"
    >
      <HeroCarousel />
      <RevealOnScroll>
        <CategoryEntries />
      </RevealOnScroll>
      <RevealOnScroll>
        <NewsStrip />
      </RevealOnScroll>
      <RevealOnScroll>
        <TrendingSection />
      </RevealOnScroll>
      <RevealOnScroll>
        <AboutTeaser />
      </RevealOnScroll>
    </SiteShell>
  );
}